// extracted by mini-css-extract-plugin
export default {"label":"CustomLabel_label__GlVSb"};